import * as _ from 'lodash';

/**
 * VCS Hosts supported by FOSSA's Quick Import integration
 */
export type VCSHost = 'bitbucket_cloud' | 'bitbucket_server' | 'gitlab' | 'github' | 'github-app' | 'azure_repos';

/**
 * Map an internal git service name constant to a human readable string.
 */
export function getGitServiceName(service: VCSHost): string {
  if (service === 'bitbucket_cloud') {
    return 'Bitbucket Cloud';
  }
  if (service === 'bitbucket_server') {
    return 'Bitbucket Server';
  }
  if (service === 'azure_repos') {
    return 'Azure Repos';
  }
  if (service === 'github-app') {
    return 'GitHub App';
  }

  return _.capitalize(service || '');
}
